var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9790_19096)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.3662 13.9306L17.262 15.6657C15.9734 14.103 14.0627 13.1818 11.9985 13.1818C9.94108 13.1818 8.03605 14.0969 6.7473 15.6508L4.64802 13.9098C6.44953 11.7376 9.12069 10.4545 11.9985 10.4545C14.8858 10.4545 17.5648 11.7461 19.3662 13.9306ZM23.546 10.4258L21.4474 12.1675C19.1285 9.37359 15.6994 7.72727 11.9985 7.72727C8.30272 7.72727 4.8779 9.369 2.55897 12.1563L0.462402 10.4121C3.29411 7.00839 7.48383 5 11.9985 5C16.5195 5 20.7144 7.01399 23.546 10.4258Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1187 17.3545L13.039 19.1188L11.9617 20L10.933 19.1486L8.80469 17.4432C9.57532 16.4815 10.7412 15.9091 11.9983 15.9091C13.2149 15.9091 14.3472 16.4451 15.1187 17.3545Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9790_19096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.a9557b46917bf8a05fe20c273fd0cc9c.svg";
export { ForwardRef as ReactComponent };